import React from 'react';

export const renderTags = (tagObject) => {
  if (!tagObject) return null;

  // Handle if tagObject is a string
  if (typeof tagObject === 'string') {
    return <span className="blog-tag">{tagObject}</span>;
  }

  // If it's an object, loop through the values
  try {
    const tagObj = typeof tagObject === 'string' ? JSON.parse(tagObject) : tagObject;
    return Object.values(tagObj).map((tag, index) => (
      <span key={index} className="blog-tag me-2">{tag}</span>
    ));
  } catch (error) {
    return null;
  }
};
